module.exports = __webpack_public_path__ + "img/0-lg.ebca7d93.jpg";